var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5L6.55884 10.1471V15.4706",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.3828V22.8828",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85303 8.05884L11.5001 13L20.7648 8.05884",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.78868C11.3094 2.61004 11.6906 2.61004 12 2.78868L20.0933 7.46132C20.4027 7.63996 20.5933 7.97008 20.5933 8.32735V17.6726C20.5933 18.0299 20.4027 18.36 20.0933 18.5387L12 23.2113C11.6906 23.39 11.3094 23.39 11 23.2113L2.90673 18.5387C2.59733 18.36 2.40673 18.0299 2.40673 17.6726V8.32735C2.40673 7.97008 2.59733 7.63996 2.90673 7.46132L11 2.78868Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.4ed0338bf228dcc4ba5ef7ca282049bb.svg";
export { ForwardRef as ReactComponent };